<fieldset name="basic" ngModelGroup="userFormBasicFieldset" #userFormBasicFieldset="ngModelGroup">
    <form-field-input name="first_name" [required]="true" [(ngModel)]="user.first_name"
                      [label]="'First name' | translate" [placeholder]="'First name' | translate"
                      type="text"></form-field-input>

    <form-field-input name="last_name" [(ngModel)]="user.last_name" [label]="'Last name' | translate"
                      [placeholder]="'Last name' | translate" type="text"></form-field-input>

    <form-field-input name="email"
                      [required]="true"
                      [(ngModel)]="user.email"
                      [label]="'Email' | translate"
                      [placeholder]="'Email' | translate"
                      #emailInput="ngModel"
                      monEmailValidator
                      type="email"></form-field-input>

    <form-field-input *ngIf="user.id"
                      name="current_password"
                      [(ngModel)]="user.auth_user_password"
                      [label]="'Current password' | translate"
                      [placeholder]="'Current password' | translate"
                      type="password">
    </form-field-input>

    <form-field-input *ngIf="user.id"
                      name="password"
                      [(ngModel)]="user.password"
                      (ngModelChange)="passwordMatchCheck()"
                      [label]="'Password' | translate"
                      [placeholder]="'Password' | translate"
                      type="password">
    </form-field-input>

    <form-field-input *ngIf="user.id"
                      name="password_confirmation"
                      [(ngModel)]="user.password_confirmation"
                      (ngModelChange)="passwordMatchCheck()"
                      [label]="'Password confirmation' | translate"
                      [placeholder]="'Password Confirmation' | translate"
                      type="password">
    </form-field-input>

    <div class="row justify-content-around">
        <span *ngIf="user.id && (user.password !== user.password_confirmation)" class="help-block col-32" style="color: red;" translate>
                &nbsp;&nbsp;&nbsp;Passwords does not match
        </span>
    </div>
    <form-field-errors [input]="emailInput.control"></form-field-errors>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" translate>
            User is account administrator
        </label>
        <div class="col-sm-40">
            <form-field-material-switch [(ngModel)]="user.customer_admin"
                                        name="customer_admin">
            </form-field-material-switch>
        </div>
    </div>

    <form-field-select returnValue="value"
                       name="languageSelect"
                       [options]="localeOptions"
                       [label]="'Language' | translate"
                       [(ngModel)]="user.locale">
    </form-field-select>

    <form-field-input *ngIf="user.fromServer"
                      name="fromServerPassword"
                      [(ngModel)]="user.password"
                      [label]="'Password' | translate"
                      [placeholder]="'Password' | translate"
                      type="password">
    </form-field-input>
    <form-field-input *ngIf="user.fromServer"
                      name="fromServerPasswordConfirmation"
                      [(ngModel)]="user.password_confirmation"
                      [label]="'Password confirmation' | translate"
                      [placeholder]="'Password confirmation' | translate"
                      type="password">
    </form-field-input>

    <div class="form-group row">
        <label class="col-sm-8 col-form-label text-bold text-right" translate>
            Enable Export Email Notification
        </label>
        <div class="col-sm-40">
            <form-field-material-switch [(ngModel)]="user.email_notifications.exports"
                                        name="export_email">
            </form-field-material-switch>
        </div>
    </div>

    <div class="form-group row" *ngIf="!user.id">
        <label class="col-sm-8 col-form-label text-bold text-right" translate>
            Send welcome mail on creation
        </label>
        <div class="col-sm-40">
            <form-field-material-switch [(ngModel)]="user.send_welcome_email"
                                        name="no_mail">
            </form-field-material-switch>
        </div>
    </div>
</fieldset>
